
import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import { ListCountries, ListCountriesSuccess, ListCountriesError } from '../action-creators';
import { LIST_COUNTRIES } from '../actions';
import { Country } from '@common/types/data/country';


export const listCountriesEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, ListCountries>(LIST_COUNTRIES),
    mergeMap(async () => {
      try {
        const countries: Country[] = await fetch(`${process.env.REACT_APP_BASENAME}data/countries.json`).then((res) => res.json()).then((t) => t.countries);
        
        return new ListCountriesSuccess(countries);
      } catch (err) {
        return new ListCountriesError(err.message)
      }
    })
  );


